import React from "react";
import { SectionShell, Field, CheckboxGroup } from "./PartnerFormPrimitives";
import { PROJECT_TYPES } from "./partnerConstants";
import { toggleInArray } from "./partnerHelpers";

export default function PartnerCrewCapacity({ data, set, setRaw }) {
  const toggle = (val) => setRaw("project_types", toggleInArray(data.project_types, val));
  return (
    <SectionShell
      index={5}
      title="Crew Size & Project Capacity"
      subtitle="How big you are and what you can take on."
      testId="partner-section-capacity"
    >
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Average Crew Size or Single Person" required>
          <input className="input-br" value={data.crew_size} onChange={set("crew_size")} placeholder="e.g. 3, or Solo" required />
        </Field>
        <Field label="Number of Crews Available" required>
          <input className="input-br" value={data.num_crews} onChange={set("num_crews")} placeholder="e.g. 1" required />
        </Field>
      </div>

      <Field label="Project Types You Can Handle" required>
        <CheckboxGroup options={PROJECT_TYPES} value={data.project_types} onChange={toggle} testIdPrefix="partner-projtype" />
      </Field>

      <Field label="Capacity Limits or Typical Project Size">
        <textarea rows={2} className="textarea-br" value={data.capacity_limits} onChange={set("capacity_limits")} placeholder="e.g. up to $250k per project, or up to 3 active jobs" />
      </Field>

      <Field label="Team Structure or Staffing Notes">
        <textarea rows={2} className="textarea-br" value={data.team_notes} onChange={set("team_notes")} placeholder="Foremen, helpers, who's on payroll vs 1099, etc." />
      </Field>
    </SectionShell>
  );
}
